import { boardsApi } from '../../../api';
import type { BoardStateSetter } from '../types';

export const createFetchBoards = (set: BoardStateSetter) => {
  return async (): Promise<void> => {
    set({ isLoading: true, error: null });
    try {
      const boards = await boardsApi.list();
      set({ boards, isLoading: false });
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : 'Failed to fetch boards',
        isLoading: false,
      });
    }
  };
};
